// IMPORTAÇÃO DOS COMPONENTES----------------------------------------------------------------------
import { dispatchMessage } from './eventBus';



// VARIÁVEIS GLOBAIS DO MÓDULO
let socket = null;
let reconVIs = false
let reconAuto = false
let reconnectAttempts = 0;
const MAX_RECONNECT_ATTEMPTS = 10;
const RECONNECT_DELAY = 3000;



// CONEXÃO DO WEBSOCKET
function startWebSocket() {
  if (socket && socket.readyState === WebSocket.OPEN) return;
  socket = new WebSocket(process.env.REACT_APP_WS_URL || 'wss://www.api.toskyapps.com');

  //conexão
  socket.onopen = () => {
    reconnectAttempts = 0;
    reconVIs = false
    reconAuto = false
  };

  // recepção de mensagens do servidor
  socket.onmessage = (event) => {
    try {
      const parsed = JSON.parse(event.data);

      // recebe mensagem de confirmação de conexão
      if (parsed.event === 'client:connected') {
        // socket?.send('Olá servidor!'); // somente para desenvolvimento
        console.log(parsed.data.text)
        dispatchMessage({ type: 'ws-status', status: 'connected' }); // 🔔 Notifica app.js
      } else {
        // demais mensagens do websocket
        dispatchMessage(parsed);
      }
    } catch (err) {
      console.log('📩 Mensagem de texto recebida:', event.data);
    }
  };

  // encerramento websocket
  socket.onclose = () => {
    console.warn('❌ WebSocket desconectado');
    dispatchMessage({ type: 'ws-status', status: 'disconnected' }); // 🔔 Notifica app.js
    attemptReconnect(); //tenta reconectar
  };

  // caso erro na conexão
  socket.onerror = (error) => {
    console.error('⚠️ Erro no WebSocket:', error);
    dispatchMessage({ type: 'ws-status', status: 'error', error }); // 🔔 Notifica app.js
    socket?.close();
  };
}



// RECONEXÃO DO WEBSOCKET EM CASO DE QUEDA REPENTINA
function attemptReconnect() {
  reconAuto = true
  if (window.location.pathname === '/' || window.location.pathname === '/register') {
    console.log('WebSocket não será iniciado nesta página.');
    reconAuto = false
    return;
  }
  if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS && reconVIs === false) {
    console.error('🚫 Limite de tentativas de reconexão atingido.');
    dispatchMessage({ type: 'ws-status', status: 'failed' }); // 🔔 Notifica app.js
    reconAuto = false
    return;
  }

  reconnectAttempts++;
  console.log(`🔁 Tentando reconectar... (${reconnectAttempts})`);

  setTimeout(() => {
    startWebSocket();
  }, RECONNECT_DELAY);
}



// RECONEXÃO DO WEBSOCKET EM CASO DE PÁGINA VISIVEL
document.addEventListener('visibilitychange', () => {
  reconVIs = true
  if (document.visibilityState === 'visible' && reconAuto === false) {
    startWebSocket();
  } else {
    reconVIs = false
  }
});

startWebSocket();

export { startWebSocket, socket };